import { useCallback } from 'react';
import { useSetRecoilState } from 'recoil';
import { Percomatic } from '@biggby-coffee/percomatic-typescript';

import { screenMessageState } from '../../atoms';

export const useAddScreenMessageHandler =
	(): Percomatic.AddScreenMessageHandler => {
		const setScreenMessage = useSetRecoilState(screenMessageState);

		return useCallback(
			(message, duration) => {
				setScreenMessage({ message, duration, severity: 'ERROR' });
			},
			[setScreenMessage]
		);
	};
